'use client';

import type {TTEventMapped} from '@/@types'; // Adjust path
import CustomButton from "@/components/ui/custom/CustomButton";
import CustomImage from "@/components/ui/custom/CustomImage";
import React from 'react';

interface EventCardProps {
    item: TTEventMapped;
    isPast?: boolean;
}

export default function EventCard({item, isPast = false}: EventCardProps) {

    // == Utils
    // TODO: move to another function ?
    const formatImgUrl = (url: string): string => {
        let result = url.substring(url.indexOf('/v1'));
        result = `https://uploads.tickettailor.com${result}`;
        return result;
    };

    const formatTicketLink = (url: string): string => {
        let result = url;
        if (url.includes('?')) {
            result = url.substring(0, url.indexOf('?'));
        }
        result = `${result}?ref=atc-website`;
        // debugger;
        return result;
    };

    /**
     * Remove "(A Standup Comedy Event)"
     * @param title
     */
    const formatEventTitle = (title: string): string => {
        return title.substring(0, title.indexOf('(')).trim();
    };

    /**
     * Remove "(A Standup Comedy Event)"
     * @param title
     */
    const getEventTitleBlocks = (title: string): { title: string, subtitle: string } => {
        const fullTitle = formatEventTitle(title);
        return {
            title: fullTitle.split(":")[0],
            subtitle: fullTitle.split(":")[1],
        }
    }

    const formatGoogleMapsQueryUrl = (name: string, postal_code: string): string => {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            name + ' ' + postal_code
        )}`;
    };

    const titleBlocks = getEventTitleBlocks(item.name)


    return (
        <div className="rounded-lg overflow-hidden">

            <CustomImage
                alt={`${titleBlocks} | Event Poster`}
                src={formatImgUrl(item.images.thumbnail)}
                // TODO: we need to explicitly be setting all of the dimension params & the skeletonClassName needs to match
                width={256}
                height={256}
                skeletonClassName={"w-[256px]"}
            />


            {/*<h2 className="text-xl font-medium title-font text-gray-900 mt-5">*/}
            {/*    /!*{formatEventTitle(item.name)}*!/*/}
            {/*    {titleBlocks.title}:*/}
            {/*    <br/>*/}
            {/*    <em>{titleBlocks.subtitle}</em>*/}
            {/*</h2>*/}

            <h2 className="text-xl font-bold title-font text-gray-900 mt-5">
                {titleBlocks.title}:
            </h2>
            <h2 className="text-xl font-medium title-font text-gray-800">
                <em>{titleBlocks.subtitle}</em>
            </h2>
            <h2 className="text-lg font-bold title-font text-gray-900 mt-3 hidden">
                (A Standup Comedy Event)
            </h2>
            <h3 className="tracking-widest text-red-500 text-xs font-medium title-font">
                <a
                    href={formatGoogleMapsQueryUrl(item.venue.name, item.venue.postal_code)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {item.venue.name}{' '}
                    <span className="text-gray-800">({item.venue.postal_code})</span>
                </a>
            </h3>
            <p className="text-base leading-relaxed mt-2">{item.start.formatted}</p>
            <div className="flex justify-center">
                <div className="w-[256px]">
                    <CustomButton
                        className="link-btn my-2 w-full"
                        isBlank={true}
                        href={formatTicketLink(item.url)}
                        text={isPast ? 'See Details' : 'Buy Tickets'}
                        showArrow={true}
                        overrideWidth={false}
                    />
                </div>
            </div>
        </div>
    );
}
